import React from 'react';
import MyGoogleMap from './myGoogleMaps'


export const GoogleMap = () => {
      return (
            <MyGoogleMap />
      )
}